import { combineClassNames } from '@common/utils/combineClassNames';
import React, { useCallback, useEffect, useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';

export type ColorInputOwnProps = {
  input: {
    value: string;
    onChange: (newColor: string) => void;
  };
  className?: string;
  colorPickerClassName?: string;
  colorPickerInnerClassName?: string;
  defaultColor?: string;
  hideValue?: boolean;
  colorInputPreviewClassName?: string;
};

export const ColorInput = ({
  input,
  defaultColor,
  hideValue,
  className,
  colorPickerClassName,
  colorPickerInnerClassName,
  colorInputPreviewClassName
}: ColorInputOwnProps) => {
  const [preview, setPreview] = useState(input.value || defaultColor);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    setPreview(input.value || defaultColor);
  }, [input.value, defaultColor, setPreview]);

  const onChange = useCallback(
    (color: ColorResult) => {
      setPreview(color.hex);
      input.onChange(color.hex);
    },
    [input, setPreview]
  );

  return (
    <div className="ColorInput">
      <div
        className={combineClassNames('ColorInput__Input', className)}
        onClick={() => setShowPicker(true)}
      >
        <div
          className={combineClassNames('ColorInput__Input__Preview', colorInputPreviewClassName)}
          style={{ backgroundColor: preview }}
        />
        {!hideValue && <input disabled type="text" value={preview} />}
      </div>
      {showPicker && (
        <>
          <div
            className="ColorInput__Backdrop"
            onClick={() => setShowPicker(false)}
          />
          <div
            className={combineClassNames(
              'ColorInput__Picker',
              colorPickerClassName
            )}
          >
            <div
              className={combineClassNames(
                'ColorInput__Picker__Inner',
                colorPickerInnerClassName
              )}
            >
              <SketchPicker
                disableAlpha
                color={preview}
                presetColors={[]}
                onChange={onChange}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
